import { getAllLinks } from "api";
import useQuery from "./useQuery"
import { showErrorModal } from "utils"

const useGetLinks = () => {
  const { data } = useQuery({
    queryFn: getAllLinks,
    onError: err => {
      showErrorModal({ err });
    }
  });

  const links = data?.data?.links;
  const linksOptions = links?.map(data => ({
    value: data.id,
    label: data.nombre,
  }));

  return {
    links,
    linksOptions,
  }
};

export default useGetLinks;